import type { AppOrResourceName } from './types'

export const UNLOCK_BUTTON_APP_TEXT: Partial<{
  [x in AppOrResourceName]: string
}> = {
  ratings: 'ratings',
  projects: 'all projects',
}
